import { Menu } from "antd";
import {
    GroupOutlined,
    FileOutlined,
    HomeOutlined,
    UploadOutlined,
    UserOutlined,
    ProductOutlined,
    OrderedListOutlined,
    SyncOutlined,
    BarChartOutlined,
    ControlOutlined,
    FileTextOutlined,
    UnorderedListOutlined,
    DownloadOutlined,
    UsergroupAddOutlined,
    CodeOutlined,
    DashboardOutlined,
    WechatOutlined,
  } from "@ant-design/icons";
import { preAuthzElementFn } from "../security/Authz";
import { Books, ChartArcs, ChartArrows, ChartDots, Dashboard } from "../../ImportData";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";



function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: any[],
    authelementname?: any
  ): any {
    
  
      return {
        key,
        icon,
        children,
        label,
        authelementname,
        };
  }

const items: any[] = [
    getItem(
      "Dashboard",
      "/home",
      <Dashboard />,
      undefined,
      "ticketmanager,ticketadmin,superadmin"
    ),
    getItem("Booking", "/home/booking", <ChartArcs />, undefined),
    getItem("Master", "/home/master/home", <Books />),
    getItem("WhatsApp Business", "/home/whatsappbusiness", <WechatOutlined  />, undefined, "ticketmanager,ticketadmin,superadmin"),
    getItem("Accounting", "/home/accounting", <ChartArrows />, [
      getItem("Receivables", "/home/accounting/receivable", <UsergroupAddOutlined />),
      getItem(
        "Accounting Dashboard",
        "/home/accounting/",
        <UsergroupAddOutlined />
      ),
      getItem("Invoice", "/home/accounting/invoices", <UsergroupAddOutlined />),
      getItem("Banking", "/home/accounting/banking", <UsergroupAddOutlined />),
      getItem("Expenses", "/home/accounting/expenses", <UsergroupAddOutlined />),
      getItem("Reports", "/home/accounting/reports", <BarChartOutlined />),
      getItem(
        "Documents",
        "/home/accounting/documents",
        <UsergroupAddOutlined />
      ),
    ]),
    getItem("HRMS", "/home/hrms", <ChartDots />, [
      getItem(
        "Oraganization Hierarchy",
        "/home/hrms/organization/hierarchy",
        <UsergroupAddOutlined />
      ),
      getItem(
        "Permission Assignment",
        "/home/hrms/permissionassignment",
        <UsergroupAddOutlined />
      ),
    ]),
    getItem("Users", "/home/user", <UserOutlined />, undefined),
    getItem(
      "Company",
      "/home/company",
      <GroupOutlined />,
      undefined,
      "systemadmin"
    ),
    getItem(
      "Ticket Inventory",
      "",
      <ProductOutlined />,
      [
        getItem(
          "Upload List",
          "/home/ticketinventory/list",
          <UploadOutlined />,
          undefined,
          "inventory-upload-list"
        ),
        getItem("List", "/home/ticketinventory/list2", <OrderedListOutlined />, undefined, "inventory-list2"),
        getItem(
          "Product List",
          "/home/ticketinventory/productlist",
          <OrderedListOutlined />,
          undefined,
          "inventory-product-list"
        ),
        getItem(
          "Download",
          "/home/ticketinventory/download",
          <DownloadOutlined />,
          undefined,
          "inventory-download"
        ),
      ],
      "inventory"
    ),
    getItem(
      "Itinerary",
      "",
      <FileTextOutlined />,
      [
        getItem("Itinerary Product", "/home/itinerary/list", <SyncOutlined />),
        getItem(
          "Itinerary Quotations",
          "/home/itinerary/quotationlist",
          <UnorderedListOutlined />
        ),
      ],
      "ticketmanager,ticketadmin,superadmin"
    ),
  
    getItem("System Master", "/home/system/master", <ControlOutlined />),
  
    getItem("Operation", "/home/operation", <FileOutlined />),
  ];
  


export const SideMenu = () => {
  const [menuItems, setMenuItems] = useState<any[]>([]);
  const {permissedElements} = useSelector((state: any) => state.hierarchicalElement);
  useEffect(() => {
    
    const menuItems = items.filter((item) => item?.authelementname ? preAuthzElementFn(item?.authelementname) : true    );
    menuItems.forEach((item) => {
      if(item?.children) {
        item.children = item.children.filter((child: any) => child?.authelementname ? preAuthzElementFn(child?.authelementname) : true);
      }
    });
    console.log("menuItems", permissedElements, menuItems);
    setMenuItems(menuItems);
  }, [permissedElements]);
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Menu
      items={menuItems}
      onClick={(item) => {
        navigate(item.key);
      }}
      defaultSelectedKeys={[location.pathname]}
      mode="inline"
    />
  );
};

